import Vue from "vue";
import Vuex from "vuex";
import clientes from "../components/Personas/clientes.vuex";
import Auth from "../components/Auth/auth.vuex";
import Categorias from "../components/Productos/Categorias/categoria.vuex";
import Productos from "../components/Productos/productos.vuex";
import Ventas from "../components/Ventas/ventas.vuex";
import Compras from "../components/Compras/compras.vuex";
import Usuarios from "../components/Usuarios/usuarios.vuex";
import UsuarioPermisos from "../components/UsuarioPermisos/usuariopermisos.vuex";
import Establecimiento from "./establecimiento";
import EstablecimientosC from "@/components/Establecimientos/establecimiento.vuex";
import AbonosVuex from "../components/Abonos/abonos.vuex";
import EstiloDocumentosVuex from "../documentos/documentos.vuex";
Vue.use(Vuex);

export const RUTA_SERVIDOR_API = process.env.VUE_APP_RUTA_API;
export const RUTA_REPORTES = process.env.VUE_APP_COMPROBANTES;

export default new Vuex.Store({
  state: {
    navigation: true,
    productos: [],
    auth: false,
    urlapi: RUTA_SERVIDOR_API,
    urlpdf: RUTA_REPORTES,
  },
  //Las mutations sirven para asignarle un valor a las variables del state
  mutations: {
    setAuth(state, value) {
      state.auth = value;
    },
    setNavigation(state) {
      state.navigation = !state.navigation;
    },
  },
  //Las actions realizan acciones de PUT, GET, POST y envian datos a las mutations con un commit
  actions: {
    autenticar({ commit }) {
      commit("setAuth", true);
    },
    setNavigation({ commit }) {
      commit("setNavigation");
    },
  },
  //Los getters son como el computed de los componentes
  getters: {
    getNavigation(state) {
      return state.navigation;
    },
    getUrlApi(state) {
      return state.urlapi;
    },
    getUrlPdf(state) {
      return state.urlpdf;
    },
  },
  modules: {
    clientes,
    UsuarioPermisos,
    Establecimiento,
    Auth,
    Categorias,
    Productos,
    Ventas,
    Usuarios,
    Compras,
    EstablecimientosC,
    AbonosVuex,
    EstiloDocumentosVuex,
  },
});
